'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BlockButton = BlockButton;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ButtonUtils = require('./ButtonUtils');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}
/* eslint-disable import/no-unresolved */


var ReactBootstrap = require('react-bootstrap');
/* eslint-enable import/no-unresolved */


var Button = ReactBootstrap.Button;

function BlockButton(_ref) {
  var size = _ref.size,
      style = _ref.style,
      handleClick = _ref.handleClick,
      children = _ref.children;
  var buttonSize = (0, _ButtonUtils.getButtonSize)(size);
  var buttonStyle = (0, _ButtonUtils.getButtonStyle)(style);
  return _react2['default'].createElement(Button, {
    bsStyle: buttonStyle,
    bsSize: buttonSize,
    onClick: handleClick,
    block: true
  }, children);
}

BlockButton.propTypes = {
  size: _propTypes2['default'].any,
  style: _propTypes2['default'].any,
  handleClick: _propTypes2['default'].func,
  children: _propTypes2['default'].node
};